import { loadScript } from "@/utils";

const scripts = ["https://yandex.ru/ads/system/context.js"];
const { domain } = useHostName();
export const useYanDexScript = () => {
  if (dexLinks.includes(domain)) {
    for (let i = 0; i < scripts.length; i++) {
      loadScript(scripts[i], () => {
        console.log("script loaded!" + scripts[i]);
      });
    }
  }
};

export const useYanDex = (size: string, index?: any) => {
  let key1 = domain;
  if (!dexLinks.includes(domain)) {
    return {};
  }
  const dexAdList = adDexMap?.[key1]?.[size];
  if (isEmptyType(dexAdList)) {
    return;
  }
  return (dexAdList || [])[index];
};
